/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["ui-top-navigation{display:flex}ui-top-navigation .nav-title a{max-width:700px;display:inline-flex!important}ui-top-navigation .nav-link-text{max-width:100%;overflow:hidden;text-overflow:ellipsis;display:inline-block;font-size:20px}"];
export { styles as styles };
